import React, { useState, useRef } from 'react';
import './UploadPanel.css';

const API = 'https://calendar.nareea.co.uk';

const UploadPanel = ({ onUploadSuccess }) => {
  const [dragging, setDragging] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [uploads, setUploads] = useState([]);
  const fileInput = useRef(null);

  const allowedTypes = ['.ics', '.csv', '.png', '.jpg', '.jpeg'];

  const handleFile = async (file) => {
    const ext = '.' + file.name.split('.').pop().toLowerCase();
    if (!allowedTypes.includes(ext)) {
      setUploads(prev => [...prev, { name: file.name, status: 'error', msg: `Format ${ext} not supported` }]);
      return;
    }

    setUploading(true);
    const formData = new FormData();
    formData.append('file', file);

    try {
      const res = await fetch(`${API}/api/upload`, { method: 'POST', body: formData });
      const data = await res.json();

      if (data.success) {
        setUploads(prev => [...prev, { name: file.name, status: 'success', msg: `Uploaded & archived` }]);
        if (onUploadSuccess) onUploadSuccess(data);
      } else {
        setUploads(prev => [...prev, { name: file.name, status: 'error', msg: data.error }]);
      }
    } catch (err) {
      setUploads(prev => [...prev, { name: file.name, status: 'error', msg: 'Upload failed' }]);
    } finally {
      setUploading(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    const files = Array.from(e.dataTransfer.files);
    files.forEach(handleFile);
  };

  const handleSelect = (e) => {
    const files = Array.from(e.target.files);
    files.forEach(handleFile);
  };

  return (
    <div className="upload-panel">
      <div className="upload-header">
        <h3>Upload Calendar Files</h3>
        <span className="upload-subtitle">ICS · CSV · PNG · JPG — auto-archived on upload</span>
      </div>

      <div
        className={`drop-zone ${dragging ? 'dragging' : ''} ${uploading ? 'uploading' : ''}`}
        onDragOver={(e) => { e.preventDefault(); setDragging(true); }}
        onDragLeave={() => setDragging(false)}
        onDrop={handleDrop}
        onClick={() => fileInput.current.click()}
      >
        <input
          ref={fileInput}
          type="file"
          multiple
          accept=".ics,.csv,.png,.jpg,.jpeg"
          onChange={handleSelect}
          style={{ display: 'none' }}
        />
        {uploading ? (
          <div className="drop-content">
            <div className="spinner"></div>
            <p>Uploading...</p>
          </div>
        ) : dragging ? (
          <div className="drop-content">
            <div className="drop-icon"></div>
            <p>Drop files here</p>
          </div>
        ) : (
          <div className="drop-content">
            <div className="drop-icon"></div>
            <p>Drag & drop files here</p>
            <p className="drop-hint">or click to browse</p>
            <div className="format-badges">
              {allowedTypes.map(t => (
                <span key={t} className="format-badge">{t}</span>
              ))}
            </div>
          </div>
        )}
      </div>

      {uploads.length > 0 && (
        <div className="upload-log">
          <div className="log-header">
            Upload History
            <button className="clear-btn" onClick={() => setUploads([])}>Clear</button>
          </div>
          {uploads.map((u, i) => (
            <div key={i} className={`log-item ${u.status}`}>
              <span className="log-name">{u.name}</span>
              <span className="log-msg">{u.msg}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default UploadPanel;
